import React, {useContext, useEffect, useState} from "react";
import SpeakerIcon from '@mui/icons-material/Speaker'
import FastfoodIcon from '@mui/icons-material/Speaker'
import PictureInPictureAltIcon from '@mui/icons-material/PictureInPictureAlt';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Grid from '@mui/material/Grid'; 
import SingleCard from "./SingleCard"
import { AppContext } from "../../App";

export default function PressPack(){

  const { eventDetails, artistInfo } = useContext(AppContext)

  if(artistInfo === []){
    console.log("artist info is an empty array")
  } else {
    console.log("artist info is now populated")
  }

  return(
    <div className="presspack-container">
      <h3 className="section-title">
        Press Pack and Downloads
      </h3>

      {artistInfo.length === 0 ?
      <p>Loading...</p> :
      
      <Grid container spacing={0.5}>
        <Grid sx={{padding: '0.5em'}} xs={6} item={true}>
          <SingleCard name="techRider" bandInfo={artistInfo} icon={<SpeakerIcon sx={{fontSize:'3em'}}/>} title="Technical Rider"/>
        </Grid>
        <Grid sx={{padding: '0.5em'}} xs={6} item={true}>
          <SingleCard name="hospitalityRider" bandInfo={artistInfo} icon={<FastfoodIcon sx={{fontSize:'3em'}}/>} title="Hospitality Rider"/>
        </Grid>
        <Grid sx={{padding: '0.5em'}} xs={6} item={true}>
          <SingleCard name="stagePlan" bandInfo={artistInfo} icon={<PictureInPictureAltIcon sx={{fontSize:'3em'}}/>} title="Stage Plan"/>
        </Grid>
        {/* <Grid sx={{padding: '0.5em'}} xs={6} item={true}>
          <SingleCard name="eventTravel" standard={false} bandInfo={artistInfo} icon={<FlightIcon sx={{fontSize:'3em'}}/>} title="Travel Details"/>
        </Grid> */}
        {/* <Grid sx={{padding: '0.5em'}} xs={4} item={true}>
          <SingleCard name="contract" standard={false} bandInfo={artistInfo} icon={<TextSnippetIcon sx={{fontSize:'3em'}}/>} title="Contract"/>
        </Grid> */}
        {/* <Grid sx={{padding: '0.5em'}} xs={4} item={true}>
          <SingleCard name="invoice" standard={false} bandInfo={artistInfo} icon={<ReceiptLongIcon sx={{fontSize:'3em'}}/>} title="Invoice"/>
        </Grid> */}
        <Grid sx={{padding: '0.5em'}} xs={6} item={true}>
          <SingleCard name="pressPhotos" bandInfo={artistInfo} icon={<CameraAltIcon sx={{fontSize:'3em'}}/>} title="Press Photos"/>
        </Grid>
      </Grid>}
    </div>
  )
}